{
  "switchToDark": "Prebaci na tamni način",
  "switchToLight": "Prebaci na svijetli način",
  "toggleMenu": "Otvori meni",
  "toggleLanguage": "Promijeni jezik",
  "firstPage": "Prva stranica",
  "previousPage": "Prethodna stranica",
  "nextPage": "Sljedeća stranica",
  "lastPage": "Posljednja stranica"
}
